import { grey } from "@mui/material/colors";

const styles = {
  logoImage: {
    width: '82px',
    height: '82px',
  },
  container: {
    maxWidth: "400px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 0,
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontSize: {
      xs: "22px",
      sm: "28px",
      md: "28px",
      lg: "36px",
      xl: "40px",
    },
    marginTop: "36px",
    fontWeight: "600",
    color: grey["800"],
  },
  subtitle: {
    fontSize: {
      xs: "12px",
      sm: "12px",
      md: "12px",
      lg: "14px",
      xl: "16px",
    },
    color: grey["700"],
    textAlign: "center",
  },
};

export default styles;
